import React, { useEffect } from "react";
import { Media } from "reactstrap";
import Avatar from "@material-ui/core/Avatar";
import userImage from "../../static/img_avatar.png";
import NotificationServices from "../../services/notficationService";
import { withRouter } from "react-router-dom";
import { 
  Card, 
  CardContent, 
  Typography, 
  Box, 
  Badge,
  Divider 
} from "@mui/material";
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import CircleIcon from '@mui/icons-material/Circle';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

const Notifications = ({ data, history }) => {
  const navigation = async (notifications) => {
    let details = NotificationServices.readnotification(notifications);
    console.log(notifications);
    history.push(`${notifications.page}`);
  };

  const formatDateTime = (date) => {
    const notificationDate = new Date(date);
    const now = new Date();
    const diffInHours = Math.floor((now - notificationDate) / (1000 * 60 * 60));
    const diffInDays = Math.floor(diffInHours / 24);
    
    if (diffInHours < 1) {
      const diffInMinutes = Math.floor((now - notificationDate) / (1000 * 60));
      return `${diffInMinutes} min${diffInMinutes !== 1 ? 's' : ''} ago`;
    } else if (diffInHours < 24) {
      return `${diffInHours} hour${diffInHours !== 1 ? 's' : ''} ago`;
    } else if (diffInDays < 7) {
      return `${diffInDays} day${diffInDays !== 1 ? 's' : ''} ago`;
    } else {
      return notificationDate.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      });
    }
  };

  // Function to get random color for avatar based on user name
  const getAvatarColor = (name) => {
    if (!name) return '#1976d2';
    
    const colors = [
      '#1976d2', // Blue
      '#2e7d32', // Green
      '#ed6c02', // Orange
      '#d32f2f', // Red
      '#7b1fa2', // Purple
      '#00796b', // Teal
      '#c2185b', // Pink
      '#5d4037', // Brown
      '#455a64', // Blue Grey
    ];
    
    const charCode = name.charCodeAt(0) || 0;
    return colors[charCode % colors.length];
  };

  // Function to get initials from name
  const getInitials = (name) => {
    if (!name) return '?';
    return name
      .split(' ')
      .map(word => word[0])
      .join('')
      .toUpperCase()
      .substring(0, 2);
  };

  return (
    <Box sx={{ p: 1 }}>
      {data.notifications && data.notifications.map((notify, index) => (
        <React.Fragment key={notify._id}>
          <Card
            sx={{
              mb: 1.5,
              borderRadius: '12px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
              border: '1px solid #e0e0e0',
              transition: 'all 0.2s ease',
              cursor: 'pointer',
              '&:hover': {
                transform: 'translateY(-2px)',
                boxShadow: '0 4px 12px rgba(0,0,0,0.12)',
                backgroundColor: '#fafafa',
              }
            }}
            onClick={() => navigation(notify)}
          >
            <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
              <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                {/* Avatar with Status Indicator */}
                <Box sx={{ position: 'relative' }}>
                  {/* <Avatar
                  tag={Media}
                    sx={{
                      width: 48,
                      height: 48,
                      fontSize: '1rem',
                      fontWeight: 600,
                      backgroundColor: getAvatarColor(notify.from?.name),
                      border: '2px solid white',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                    }}
                    src={notify.from?.display_picture || userImage}
                    alt={notify.from?.name || 'User'}
                  >
                    {!notify.from?.display_picture && getInitials(notify.from?.name || '?')}
                  </Avatar> */}
                  <Avatar
            tag={Media}
            object
            src={notify.from ? notify.from.display_picture : userImage}
            title=""
            style={{ cursor: "pointer", border:'1px solid black' }}
          />

                  
                  {/* Unread Indicator */}
                  {!notify.read && (
                    <Badge
                      color="error"
                      variant="dot"
                      sx={{
                        position: 'absolute',
                        top: -2,
                        right: -2,
                        '& .MuiBadge-badge': {
                          width: 10,
                          height: 10,
                          borderRadius: '50%',
                          border: '2px solid white',
                        }
                      }}
                    />
                  )}
                </Box>

                {/* Notification Content */}
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  {/* Sender Name and Time */}
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
                    <Typography
                      variant="subtitle2"
                      sx={{
                        fontWeight: 600,
                        color: '#333',
                        fontSize: '0.9rem',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      }}
                    >
                      {notify.from?.name || 'System'}
                    </Typography>
                    
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                      <AccessTimeIcon sx={{ fontSize: '0.9rem', color: '#666' }} />
                      <Typography
                        variant="caption"
                        sx={{
                          color: '#666',
                          fontSize: '0.75rem',
                          fontWeight: 500,
                        }}
                      >
                        {formatDateTime(notify.date)}
                      </Typography>
                    </Box>
                  </Box>

                  {/* Message */}
                  <Typography
                    variant="body2"
                    sx={{
                      color: '#555',
                      fontSize: '0.875rem',
                      lineHeight: 1.4,
                      display: '-webkit-box',
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden',
                      mb: 0.5,
                    }}
                  >
                    {notify.message}
                  </Typography>

                  {/* Action Type Indicator */}
                  {notify.type && (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.5 }}>
                      <NotificationsActiveIcon sx={{ fontSize: '0.9rem', color: '#1976d2' }} />
                      <Typography
                        variant="caption"
                        sx={{
                          color: '#1976d2',
                          fontSize: '0.75rem',
                          fontWeight: 600,
                          textTransform: 'capitalize',
                        }}
                      >
                        {notify.type.replace('_', ' ')}
                      </Typography>
                    </Box>
                  )}
                </Box>
              </Box>
            </CardContent>
          </Card>

          {/* Divider between notifications */}
          {index < data.notifications.length - 1 && (
            <Divider sx={{ my: 1, opacity: 0.5 }} />
          )}
        </React.Fragment>
      ))}
      
      {/* Empty State */}
      {data.notifications && data.notifications.length === 0 && (
        <Box
          sx={{
            textAlign: 'center',
            py: 8,
            px: 3,
          }}
        >
          <Box
            sx={{
              width: 80,
              height: 80,
              borderRadius: '50%',
              backgroundColor: '#f0f2f5',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 16px',
            }}
          >
            <NotificationsActiveIcon sx={{ fontSize: 40, color: '#9e9e9e' }} />
          </Box>
          <Typography variant="h6" fontWeight={600} gutterBottom sx={{ color: '#555' }}>
            No notifications yet
          </Typography>
          <Typography variant="body2" color="text.secondary">
            You're all caught up! New notifications will appear here.
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default withRouter(Notifications);



// import React, { useState } from "react";
// import { Media } from "reactstrap";
// import Avatar from "@material-ui/core/Avatar";
// import userImage from "../../static/img_avatar.png";
// import NotificationServices from "../../services/notficationService";
// import { withRouter } from "react-router-dom";
// import { 
//   Card, 
//   CardContent, 
//   Typography, 
//   Box, 
//   Badge,
//   Divider,
//   Button,
//   IconButton,
//   Menu,
//   MenuItem,
//   Tooltip,
//   CircularProgress
// } from "@mui/material";
// import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
// import AccessTimeIcon from '@mui/icons-material/AccessTime';
// import MoreVertIcon from '@mui/icons-material/MoreVert';
// import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
// import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
// import { toast } from "react-toastify";

// const Notifications = ({ data, history, onNotificationsUpdate }) => {
//   const [anchorEl, setAnchorEl] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [notifications, setNotifications] = useState(data?.notifications || []);
  
//   const navigation = async (notifications) => {
//     try {
//       // Mark as read first
//       if (!notifications.read) {
//         await markAsRead(notifications._id);
//       }
//       // Then navigate
//       history.push(`${notifications.page}`);
//     } catch (error) {
//       console.error("Navigation error:", error);
//       toast.error("Error opening notification");
//     }
//   };

//   const markAsRead = async (notificationId) => {
//     try {
//       setLoading(true);
//       const response = await NotificationServices.readnotification({ _id: notificationId });
      
//       if (response && response.status === 200) {
//         // Update local state
//         setNotifications(prev => 
//           prev.map(notify => 
//             notify._id === notificationId ? { ...notify, read: true } : notify
//           )
//         );
        
//         // Update parent component if callback provided
//         if (onNotificationsUpdate) {
//           onNotificationsUpdate();
//         }
        
//         toast.success("Notification marked as read");
//       } else {
//         toast.error("Failed to mark as read");
//       }
//     } catch (error) {
//       console.error("Error marking as read:", error);
//       toast.error("Error marking notification as read");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const markAllAsRead = async () => {
//     try {
//       setLoading(true);
//       const unreadNotifications = notifications.filter(notify => !notify.read);
      
//       if (unreadNotifications.length === 0) {
//         toast.info("All notifications are already read");
//         return;
//       }

//       // Call API to mark all as read
//       const response = await NotificationServices.markAllAsRead();
      
//       if (response && response.status === 200) {
//         // Update all notifications to read
//         setNotifications(prev => 
//           prev.map(notify => ({ ...notify, read: true }))
//         );
        
//         // Update parent component if callback provided
//         if (onNotificationsUpdate) {
//           onNotificationsUpdate();
//         }
        
//         toast.success(`Marked ${unreadNotifications.length} notification(s) as read`);
//       } else {
//         toast.error("Failed to mark all as read");
//       }
//     } catch (error) {
//       console.error("Error marking all as read:", error);
//       toast.error("Error marking all notifications as read");
//     } finally {
//       setLoading(false);
//       handleCloseMenu();
//     }
//   };

//   const deleteAllNotifications = async () => {
//     try {
//       setLoading(true);
//       const response = await NotificationServices.deleteAllNotifications();
      
//       if (response && response.status === 200) {
//         // Clear all notifications
//         setNotifications([]);
        
//         // Update parent component if callback provided
//         if (onNotificationsUpdate) {
//           onNotificationsUpdate();
//         }
        
//         toast.success("All notifications deleted");
//       } else {
//         toast.error("Failed to delete notifications");
//       }
//     } catch (error) {
//       console.error("Error deleting notifications:", error);
//       toast.error("Error deleting notifications");
//     } finally {
//       setLoading(false);
//       handleCloseMenu();
//     }
//   };

//   const formatDateTime = (date) => {
//     const notificationDate = new Date(date);
//     const now = new Date();
//     const diffInHours = Math.floor((now - notificationDate) / (1000 * 60 * 60));
//     const diffInDays = Math.floor(diffInHours / 24);
    
//     if (diffInHours < 1) {
//       const diffInMinutes = Math.floor((now - notificationDate) / (1000 * 60));
//       return `${diffInMinutes} min${diffInMinutes !== 1 ? 's' : ''} ago`;
//     } else if (diffInHours < 24) {
//       return `${diffInHours} hour${diffInHours !== 1 ? 's' : ''} ago`;
//     } else if (diffInDays < 7) {
//       return `${diffInDays} day${diffInDays !== 1 ? 's' : ''} ago`;
//     } else {
//       return notificationDate.toLocaleDateString('en-US', {
//         month: 'short',
//         day: 'numeric',
//         year: 'numeric'
//       });
//     }
//   };

//   const getSenderName = (notify) => {
//     if (notify.from && notify.from.name) {
//       return notify.from.name;
//     } else if (notify.from && notify.from.username) {
//       return notify.from.username;
//     } else if (notify.senderName) {
//       return notify.senderName;
//     } else {
//       return "User";
//     }
//   };

//   const getAvatarSource = (notify) => {
//     if (notify.from && notify.from.display_picture) {
//       return notify.from.display_picture;
//     } else {
//       return userImage;
//     }
//   };

//   const handleOpenMenu = (event) => {
//     setAnchorEl(event.currentTarget);
//   };

//   const handleCloseMenu = () => {
//     setAnchorEl(null);
//   };

//   const unreadCount = notifications.filter(notify => !notify.read).length;

//   // If data prop changes, update notifications
//   React.useEffect(() => {
//     if (data?.notifications) {
//       setNotifications(data.notifications);
//     }
//   }, [data?.notifications]);

//   return (
//     <Box sx={{ p: 1 }}>
//       {/* Header with actions */}
//       <Box sx={{ 
//         display: 'flex', 
//         justifyContent: 'space-between', 
//         alignItems: 'center', 
//         mb: 2,
//         px: 1 
//       }}>
//         <Typography variant="h6" fontWeight={600}>
//           Notifications
//           {unreadCount > 0 && (
//             <Badge
//               color="error"
//               badgeContent={unreadCount}
//               sx={{ ml: 1 }}
//             />
//           )}
//         </Typography>
        
//         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//           {unreadCount > 0 && (
//             <Button
//               variant="outlined"
//               size="small"
//               startIcon={<MarkEmailReadIcon />}
//               onClick={markAllAsRead}
//               disabled={loading}
//               sx={{
//                 textTransform: 'none',
//                 fontSize: '0.85rem'
//               }}
//             >
//               Mark all as read
//             </Button>
//           )}
          
//           <Tooltip title="More actions">
//             <IconButton
//               size="small"
//               onClick={handleOpenMenu}
//               disabled={loading || notifications.length === 0}
//             >
//               <MoreVertIcon />
//             </IconButton>
//           </Tooltip>
          
//           <Menu
//             anchorEl={anchorEl}
//             open={Boolean(anchorEl)}
//             onClose={handleCloseMenu}
//           >
//             <MenuItem onClick={markAllAsRead} disabled={loading || unreadCount === 0}>
//               <MarkEmailReadIcon fontSize="small" sx={{ mr: 1 }} />
//               Mark all as read
//             </MenuItem>
//             <MenuItem onClick={deleteAllNotifications} disabled={loading}>
//               <DeleteOutlineIcon fontSize="small" sx={{ mr: 1 }} />
//               Clear all notifications
//             </MenuItem>
//           </Menu>
//         </Box>
//       </Box>

//       {loading && (
//         <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
//           <CircularProgress size={24} />
//         </Box>
//       )}

//       {notifications.map((notify, index) => (
//         <React.Fragment key={notify._id}>
//           <Card
//             sx={{
//               mb: 1.5,
//               borderRadius: '12px',
//               boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
//               border: '1px solid #e0e0e0',
//               transition: 'all 0.2s ease',
//               cursor: 'pointer',
//               opacity: notify.read ? 0.8 : 1,
//               backgroundColor: notify.read ? 'white' : '#f8fbff',
//               '&:hover': {
//                 transform: 'translateY(-2px)',
//                 boxShadow: '0 4px 12px rgba(0,0,0,0.12)',
//                 backgroundColor: notify.read ? '#fafafa' : '#f0f7ff',
//               }
//             }}
//             onClick={() => navigation(notify)}
//           >
//             <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
//               <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
//                 {/* Avatar with Status Indicator */}
//                 <Box sx={{ position: 'relative' }}>
//                   <Avatar
//                     tag={Media}
//                     object
//                     src={getAvatarSource(notify)}
//                     title={getSenderName(notify)}
//                     style={{ 
//                       cursor: "pointer", 
//                       border: '1px solid #e0e0e0',
//                       width: 48,
//                       height: 48,
//                       fontSize: '1rem',
//                       fontWeight: 600,
//                       backgroundColor: '#f0f2f5',
//                       boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
//                     }}
//                   />
                  
//                   {/* Unread Indicator */}
//                   {!notify.read && (
//                     <Badge
//                       color="error"
//                       variant="dot"
//                       sx={{
//                         position: 'absolute',
//                         top: -2,
//                         right: -2,
//                         '& .MuiBadge-badge': {
//                           width: 10,
//                           height: 10,
//                           borderRadius: '50%',
//                           border: '2px solid white',
//                         }
//                       }}
//                     />
//                   )}
//                 </Box>

//                 {/* Notification Content */}
//                 <Box sx={{ flex: 1, minWidth: 0 }}>
//                   {/* Sender Name and Time */}
//                   <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
//                     <Typography
//                       variant="subtitle2"
//                       sx={{
//                         fontWeight: 600,
//                         color: notify.read ? '#666' : '#333',
//                         fontSize: '0.9rem',
//                         whiteSpace: 'nowrap',
//                         overflow: 'hidden',
//                         textOverflow: 'ellipsis',
//                       }}
//                     >
//                       {getSenderName(notify)}
//                     </Typography>
                    
//                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
//                       <AccessTimeIcon sx={{ fontSize: '0.9rem', color: '#666' }} />
//                       <Typography
//                         variant="caption"
//                         sx={{
//                           color: '#666',
//                           fontSize: '0.75rem',
//                           fontWeight: 500,
//                         }}
//                       >
//                         {formatDateTime(notify.date)}
//                       </Typography>
//                     </Box>
//                   </Box>

//                   {/* Message */}
//                   <Typography
//                     variant="body2"
//                     sx={{
//                       color: notify.read ? '#666' : '#555',
//                       fontSize: '0.875rem',
//                       lineHeight: 1.4,
//                       display: '-webkit-box',
//                       WebkitLineClamp: 2,
//                       WebkitBoxOrient: 'vertical',
//                       overflow: 'hidden',
//                       mb: 0.5,
//                       fontWeight: notify.read ? 400 : 500,
//                     }}
//                   >
//                     {notify.message || notify.content || "New notification"}
//                   </Typography>
//                 </Box>
//               </Box>
//             </CardContent>
//           </Card>

//           {/* Divider between notifications */}
//           {index < notifications.length - 1 && (
//             <Divider sx={{ my: 1, opacity: 0.5 }} />
//           )}
//         </React.Fragment>
//       ))}
      
//       {/* Empty State */}
//       {notifications.length === 0 && (
//         <Box
//           sx={{
//             textAlign: 'center',
//             py: 8,
//             px: 3,
//           }}
//         >
//           <Box
//             sx={{
//               width: 80,
//               height: 80,
//               borderRadius: '50%',
//               backgroundColor: '#f0f2f5',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               margin: '0 auto 16px',
//             }}
//           >
//             <NotificationsActiveIcon sx={{ fontSize: 40, color: '#9e9e9e' }} />
//           </Box>
//           <Typography variant="h6" fontWeight={600} gutterBottom sx={{ color: '#555' }}>
//             No notifications yet
//           </Typography>
//           <Typography variant="body2" color="text.secondary">
//             You're all caught up! New notifications will appear here.
//           </Typography>
//         </Box>
//       )}
//     </Box>
//   );
// };

// export default withRouter(Notifications);